import iosAddCircleOutlineSvg from './ios-add-circle-outline.svg';
import iosAddCircleSvg from './ios-add-circle.svg';
import iosAddSvg from './ios-add.svg';
import iosAirplaneSvg from './ios-airplane.svg';
import iosAlarmSvg from './ios-alarm.svg';
import iosAlbumsSvg from './ios-albums.svg';
import iosAlertSvg from './ios-alert.svg';
import iosAmericanFootballSvg from './ios-american-football.svg';
import iosAnalyticsSvg from './ios-analytics.svg';
import iosApertureSvg from './ios-aperture.svg';
import iosAppsSvg from './ios-apps.svg';
import iosAppstoreSvg from './ios-appstore.svg';
import iosArchiveSvg from './ios-archive.svg';
import iosArrowBackSvg from './ios-arrow-back.svg';
import iosArrowDownSvg from './ios-arrow-down.svg';
import iosArrowDropdownCircleSvg from './ios-arrow-dropdown-circle.svg';
import iosArrowDropdownSvg from './ios-arrow-dropdown.svg';
import iosArrowDropleftCircleSvg from './ios-arrow-dropleft-circle.svg';
import iosArrowDropleftSvg from './ios-arrow-dropleft.svg';
import iosArrowDroprightCircleSvg from './ios-arrow-dropright-circle.svg';
import iosArrowDroprightSvg from './ios-arrow-dropright.svg';
import iosArrowDropupCircleSvg from './ios-arrow-dropup-circle.svg';
import iosArrowDropupSvg from './ios-arrow-dropup.svg';
import iosArrowForwardSvg from './ios-arrow-forward.svg';
import iosArrowRoundBackSvg from './ios-arrow-round-back.svg';
import iosArrowRoundDownSvg from './ios-arrow-round-down.svg';
import iosArrowRoundForwardSvg from './ios-arrow-round-forward.svg';
import iosArrowRoundUpSvg from './ios-arrow-round-up.svg';
import iosArrowUpSvg from './ios-arrow-up.svg';
import iosAtSvg from './ios-at.svg';
import iosAttachSvg from './ios-attach.svg';
import iosBackspaceSvg from './ios-backspace.svg';
import iosBarcodeSvg from './ios-barcode.svg';
import iosBaseballSvg from './ios-baseball.svg';
import iosBasketSvg from './ios-basket.svg';
import iosBasketballSvg from './ios-basketball.svg';
import iosBatteryChargingSvg from './ios-battery-charging.svg';
import iosBatteryDeadSvg from './ios-battery-dead.svg';
import iosBatteryFullSvg from './ios-battery-full.svg';
import iosBeakerSvg from './ios-beaker.svg';
import iosBedSvg from './ios-bed.svg';
import iosBeerSvg from './ios-beer.svg';
import iosBicycleSvg from './ios-bicycle.svg';
import iosBluetoothSvg from './ios-bluetooth.svg';
import iosBoatSvg from './ios-boat.svg';
import iosBodySvg from './ios-body.svg';
import iosBonfireSvg from './ios-bonfire.svg';
import iosBookSvg from './ios-book.svg';
import iosBookmarkSvg from './ios-bookmark.svg';
import iosBookmarksSvg from './ios-bookmarks.svg';
import iosBowtieSvg from './ios-bowtie.svg';
import iosBriefcaseSvg from './ios-briefcase.svg';
import iosBrowsersSvg from './ios-browsers.svg';
import iosBrushSvg from './ios-brush.svg';
import iosBugSvg from './ios-bug.svg';
import iosBuildSvg from './ios-build.svg';
import iosBulbSvg from './ios-bulb.svg';
import iosBusSvg from './ios-bus.svg';
import iosBusinessSvg from './ios-business.svg';
import iosCafeSvg from './ios-cafe.svg';
import iosCalculatorSvg from './ios-calculator.svg';
import iosCalendarSvg from './ios-calendar.svg';
import iosCallSvg from './ios-call.svg';
import iosCameraSvg from './ios-camera.svg';
import iosCarSvg from './ios-car.svg';
import iosCardSvg from './ios-card.svg';
import iosCartSvg from './ios-cart.svg';
import iosCashSvg from './ios-cash.svg';
import iosCellularSvg from './ios-cellular.svg';
import iosChatboxesSvg from './ios-chatboxes.svg';
import iosChatbubblesSvg from './ios-chatbubbles.svg';
import iosCheckboxOutlineSvg from './ios-checkbox-outline.svg';
import iosCheckboxSvg from './ios-checkbox.svg';
import iosCheckmarkCircleOutlineSvg from './ios-checkmark-circle-outline.svg';
import iosCheckmarkCircleSvg from './ios-checkmark-circle.svg';
import iosCheckmarkSvg from './ios-checkmark.svg';
import iosClipboardSvg from './ios-clipboard.svg';
import iosClockSvg from './ios-clock.svg';
import iosCloseCircleOutlineSvg from './ios-close-circle-outline.svg';
import iosCloseCircleSvg from './ios-close-circle.svg';
import iosCloseSvg from './ios-close.svg';
import iosCloudCircleSvg from './ios-cloud-circle.svg';
import iosCloudDoneSvg from './ios-cloud-done.svg';
import iosCloudDownloadSvg from './ios-cloud-download.svg';
import iosCloudOutlineSvg from './ios-cloud-outline.svg';
import iosCloudSvg from './ios-cloud.svg';
import iosCloudUploadSvg from './ios-cloud-upload.svg';
import iosCloudyNightSvg from './ios-cloudy-night.svg';
import iosCloudySvg from './ios-cloudy.svg';
import iosCodeDownloadSvg from './ios-code-download.svg';
import iosCodeSvg from './ios-code.svg';
import iosCodeWorkingSvg from './ios-code-working.svg';
import iosCogSvg from './ios-cog.svg';
import iosColorFillSvg from './ios-color-fill.svg';
import iosColorFilterSvg from './ios-color-filter.svg';
import iosColorPaletteSvg from './ios-color-palette.svg';
import iosColorWandSvg from './ios-color-wand.svg';
import iosCompassSvg from './ios-compass.svg';
import iosConstructSvg from './ios-construct.svg';
import iosContactSvg from './ios-contact.svg';
import iosContactsSvg from './ios-contacts.svg';
import iosContractSvg from './ios-contract.svg';
import iosContrastSvg from './ios-contrast.svg';
import iosCopySvg from './ios-copy.svg';
import iosCreateSvg from './ios-create.svg';
import iosCropSvg from './ios-crop.svg';
import iosCubeSvg from './ios-cube.svg';
import iosCutSvg from './ios-cut.svg';
import iosDesktopSvg from './ios-desktop.svg';
import iosDiscSvg from './ios-disc.svg';
import iosDocumentSvg from './ios-document.svg';
import iosDoneAllSvg from './ios-done-all.svg';
import iosDownloadSvg from './ios-download.svg';
import iosEaselSvg from './ios-easel.svg';
import iosEggSvg from './ios-egg.svg';
import iosExitSvg from './ios-exit.svg';
import iosExpandSvg from './ios-expand.svg';
import iosEyeOffSvg from './ios-eye-off.svg';
import iosEyeSvg from './ios-eye.svg';
import iosFastforwardSvg from './ios-fastforward.svg';
import iosFemaleSvg from './ios-female.svg';
import iosFilingSvg from './ios-filing.svg';
import iosFilmSvg from './ios-film.svg';
import iosFingerPrintSvg from './ios-finger-print.svg';
import iosFitnessSvg from './ios-fitness.svg';
import iosFlagSvg from './ios-flag.svg';
import iosFlameSvg from './ios-flame.svg';
import iosFlashOffSvg from './ios-flash-off.svg';
import iosFlashSvg from './ios-flash.svg';
import iosFlashlightSvg from './ios-flashlight.svg';
import iosFlaskSvg from './ios-flask.svg';
import iosFlowerSvg from './ios-flower.svg';
import iosFolderOpenSvg from './ios-folder-open.svg';
import iosFolderSvg from './ios-folder.svg';
import iosFootballSvg from './ios-football.svg';
import iosFunnelSvg from './ios-funnel.svg';
import iosGiftSvg from './ios-gift.svg';
import iosGitBranchSvg from './ios-git-branch.svg';
import iosGitCommitSvg from './ios-git-commit.svg';
import iosGitCompareSvg from './ios-git-compare.svg';
import iosGitMergeSvg from './ios-git-merge.svg';
import iosGitNetworkSvg from './ios-git-network.svg';
import iosGitPullRequestSvg from './ios-git-pull-request.svg';
import iosGlassesSvg from './ios-glasses.svg';
import iosGlobeSvg from './ios-globe.svg';
import iosGridSvg from './ios-grid.svg';
import iosHammerSvg from './ios-hammer.svg';
import iosHandSvg from './ios-hand.svg';
import iosHappySvg from './ios-happy.svg';
import iosHeadsetSvg from './ios-headset.svg';
import iosHeartDislikeSvg from './ios-heart-dislike.svg';
import iosHeartEmptySvg from './ios-heart-empty.svg';
import iosHeartHalfSvg from './ios-heart-half.svg';
import iosHeartSvg from './ios-heart.svg';
import iosHelpBuoySvg from './ios-help-buoy.svg';
import iosHelpCircleOutlineSvg from './ios-help-circle-outline.svg';
import iosHelpCircleSvg from './ios-help-circle.svg';
import iosHelpSvg from './ios-help.svg';
import iosHomeSvg from './ios-home.svg';
import iosHourglassSvg from './ios-hourglass.svg';
import iosIceCreamSvg from './ios-ice-cream.svg';
import iosImageSvg from './ios-image.svg';
import iosImagesSvg from './ios-images.svg';
import iosInfiniteSvg from './ios-infinite.svg';
import iosInformationCircleOutlineSvg from './ios-information-circle-outline.svg';
import iosInformationCircleSvg from './ios-information-circle.svg';
import iosInformationSvg from './ios-information.svg';
import iosJetSvg from './ios-jet.svg';
import iosJournalSvg from './ios-journal.svg';
import iosKeySvg from './ios-key.svg';
import iosKeypadSvg from './ios-keypad.svg';
import iosLaptopSvg from './ios-laptop.svg';
import iosLeafSvg from './ios-leaf.svg';
import iosLinkSvg from './ios-link.svg';
import iosListBoxSvg from './ios-list-box.svg';
import iosListSvg from './ios-list.svg';
import iosLocateSvg from './ios-locate.svg';
import iosLockSvg from './ios-lock.svg';
import iosLogInSvg from './ios-log-in.svg';
import iosLogOutSvg from './ios-log-out.svg';
import iosMagnetSvg from './ios-magnet.svg';
import iosMailOpenSvg from './ios-mail-open.svg';
import iosMailSvg from './ios-mail.svg';
import iosMailUnreadSvg from './ios-mail-unread.svg';
import iosMaleSvg from './ios-male.svg';
import iosManSvg from './ios-man.svg';
import iosMapSvg from './ios-map.svg';
import iosMedalSvg from './ios-medal.svg';
import iosMedicalSvg from './ios-medical.svg';
import iosMedkitSvg from './ios-medkit.svg';
import iosMegaphoneSvg from './ios-megaphone.svg';
import iosMenuSvg from './ios-menu.svg';
import iosMicOffSvg from './ios-mic-off.svg';
import iosMicSvg from './ios-mic.svg';
import iosMicrophoneSvg from './ios-microphone.svg';
import iosMoonSvg from './ios-moon.svg';
import iosMoreSvg from './ios-more.svg';
import iosMoveSvg from './ios-move.svg';
import iosMusicalNoteSvg from './ios-musical-note.svg';
import iosMusicalNotesSvg from './ios-musical-notes.svg';
import iosNavigateSvg from './ios-navigate.svg';
import iosNotificationsOffSvg from './ios-notifications-off.svg';
import iosNotificationsOutlineSvg from './ios-notifications-outline.svg';
import iosNotificationsSvg from './ios-notifications.svg';
import iosNuclearSvg from './ios-nuclear.svg';
import iosNutritionSvg from './ios-nutrition.svg';
import iosOpenSvg from './ios-open.svg';
import iosOptionsSvg from './ios-options.svg';
import iosOutletSvg from './ios-outlet.svg';
import iosPaperPlaneSvg from './ios-paper-plane.svg';
import iosPaperSvg from './ios-paper.svg';
import iosPartlySunnySvg from './ios-partly-sunny.svg';
import iosPauseSvg from './ios-pause.svg';
import iosPawSvg from './ios-paw.svg';
import iosPeopleSvg from './ios-people.svg';
import iosPersonAddSvg from './ios-person-add.svg';
import iosPersonSvg from './ios-person.svg';
import iosPhoneLandscapeSvg from './ios-phone-landscape.svg';
import iosPhonePortraitSvg from './ios-phone-portrait.svg';
import iosPhotosSvg from './ios-photos.svg';
import iosPieSvg from './ios-pie.svg';
import iosPinSvg from './ios-pin.svg';
import iosPintSvg from './ios-pint.svg';
import iosPizzaSvg from './ios-pizza.svg';
import iosPlanetSvg from './ios-planet.svg';
import iosPlayCircleSvg from './ios-play-circle.svg';
import iosPlaySvg from './ios-play.svg';
import iosPodiumSvg from './ios-podium.svg';
import iosPowerSvg from './ios-power.svg';
import iosPricetagSvg from './ios-pricetag.svg';
import iosPricetagsSvg from './ios-pricetags.svg';
import iosPrintSvg from './ios-print.svg';
import iosPulseSvg from './ios-pulse.svg';
import iosQrScannerSvg from './ios-qr-scanner.svg';
import iosQuoteSvg from './ios-quote.svg';
import iosRadioButtonOffSvg from './ios-radio-button-off.svg';
import iosRadioButtonOnSvg from './ios-radio-button-on.svg';
import iosRadioSvg from './ios-radio.svg';
import iosRainySvg from './ios-rainy.svg';
import iosRecordingSvg from './ios-recording.svg';
import iosRedoSvg from './ios-redo.svg';
import iosRefreshCircleSvg from './ios-refresh-circle.svg';
import iosRefreshSvg from './ios-refresh.svg';
import iosRemoveCircleOutlineSvg from './ios-remove-circle-outline.svg';
import iosRemoveCircleSvg from './ios-remove-circle.svg';
import iosRemoveSvg from './ios-remove.svg';
import iosReorderSvg from './ios-reorder.svg';
import iosRepeatSvg from './ios-repeat.svg';
import iosResizeSvg from './ios-resize.svg';
import iosRestaurantSvg from './ios-restaurant.svg';
import iosReturnLeftSvg from './ios-return-left.svg';
import iosReturnRightSvg from './ios-return-right.svg';
import iosReverseCameraSvg from './ios-reverse-camera.svg';
import iosRewindSvg from './ios-rewind.svg';
import iosRibbonSvg from './ios-ribbon.svg';
import iosRocketSvg from './ios-rocket.svg';
import iosRoseSvg from './ios-rose.svg';
import iosSadSvg from './ios-sad.svg';
import iosSaveSvg from './ios-save.svg';
import iosSchoolSvg from './ios-school.svg';
import iosSearchSvg from './ios-search.svg';
import iosSendSvg from './ios-send.svg';
import iosSettingsSvg from './ios-settings.svg';
import iosShareAltSvg from './ios-share-alt.svg';
import iosShareSvg from './ios-share.svg';
import iosShirtSvg from './ios-shirt.svg';
import iosShuffleSvg from './ios-shuffle.svg';
import iosSkipBackwardSvg from './ios-skip-backward.svg';
import iosSkipForwardSvg from './ios-skip-forward.svg';
import iosSnowSvg from './ios-snow.svg';
import iosSpeedometerSvg from './ios-speedometer.svg';
import iosSquareOutlineSvg from './ios-square-outline.svg';
import iosSquareSvg from './ios-square.svg';
import iosStarHalfSvg from './ios-star-half.svg';
import iosStarOutlineSvg from './ios-star-outline.svg';
import iosStarSvg from './ios-star.svg';
import iosStatsSvg from './ios-stats.svg';
import iosStopwatchSvg from './ios-stopwatch.svg';
import iosSubwaySvg from './ios-subway.svg';
import iosSunnySvg from './ios-sunny.svg';
import iosSwapSvg from './ios-swap.svg';
import iosSwitchSvg from './ios-switch.svg';
import iosSyncSvg from './ios-sync.svg';
import iosTabletLandscapeSvg from './ios-tablet-landscape.svg';
import iosTabletPortraitSvg from './ios-tablet-portrait.svg';
import iosTennisballSvg from './ios-tennisball.svg';
import iosTextSvg from './ios-text.svg';
import iosThermometerSvg from './ios-thermometer.svg';
import iosThumbsDownSvg from './ios-thumbs-down.svg';
import iosThumbsUpSvg from './ios-thumbs-up.svg';
import iosThunderstormSvg from './ios-thunderstorm.svg';
import iosTimeSvg from './ios-time.svg';
import iosTimerSvg from './ios-timer.svg';
import iosTodaySvg from './ios-today.svg';
import iosTrainSvg from './ios-train.svg';
import iosTransgenderSvg from './ios-transgender.svg';
import iosTrashSvg from './ios-trash.svg';
import iosTrendingDownSvg from './ios-trending-down.svg';
import iosTrendingUpSvg from './ios-trending-up.svg';
import iosTrophySvg from './ios-trophy.svg';
import iosTvSvg from './ios-tv.svg';
import iosUmbrellaSvg from './ios-umbrella.svg';
import iosUndoSvg from './ios-undo.svg';
import iosUnlockSvg from './ios-unlock.svg';
import iosVideocamSvg from './ios-videocam.svg';
import iosVolumeHighSvg from './ios-volume-high.svg';
import iosVolumeLowSvg from './ios-volume-low.svg';
import iosVolumeMuteSvg from './ios-volume-mute.svg';
import iosVolumeOffSvg from './ios-volume-off.svg';
import iosWalkSvg from './ios-walk.svg';
import iosWalletSvg from './ios-wallet.svg';
import iosWarningSvg from './ios-warning.svg';
import iosWatchSvg from './ios-watch.svg';
import iosWaterSvg from './ios-water.svg';
import iosWifiSvg from './ios-wifi.svg';
import iosWineSvg from './ios-wine.svg';
import iosWomanSvg from './ios-woman.svg';
import logoAndroidSvg from './logo-android.svg';
import logoAngularSvg from './logo-angular.svg';
import logoAppleSvg from './logo-apple.svg';
import logoBitbucketSvg from './logo-bitbucket.svg';
import logoBitcoinSvg from './logo-bitcoin.svg';
import logoBufferSvg from './logo-buffer.svg';
import logoChromeSvg from './logo-chrome.svg';
import logoClosedCaptioningSvg from './logo-closed-captioning.svg';
import logoCodepenSvg from './logo-codepen.svg';
import logoCss3Svg from './logo-css3.svg';
import logoDesignernewsSvg from './logo-designernews.svg';
import logoDribbbleSvg from './logo-dribbble.svg';
import logoDropboxSvg from './logo-dropbox.svg';
import logoEuroSvg from './logo-euro.svg';
import logoFacebookSvg from './logo-facebook.svg';
import logoFlickrSvg from './logo-flickr.svg';
import logoFoursquareSvg from './logo-foursquare.svg';
import logoFreebsdDevilSvg from './logo-freebsd-devil.svg';
import logoGameControllerASvg from './logo-game-controller-a.svg';
import logoGameControllerBSvg from './logo-game-controller-b.svg';
import logoGithubSvg from './logo-github.svg';
import logoGoogleSvg from './logo-google.svg';
import logoGoogleplusSvg from './logo-googleplus.svg';
import logoHackernewsSvg from './logo-hackernews.svg';
import logoHtml5Svg from './logo-html5.svg';
import logoInstagramSvg from './logo-instagram.svg';
import logoIonicSvg from './logo-ionic.svg';
import logoIonitronSvg from './logo-ionitron.svg';
import logoJavascriptSvg from './logo-javascript.svg';
import logoLinkedinSvg from './logo-linkedin.svg';
import logoMarkdownSvg from './logo-markdown.svg';
import logoModelSSvg from './logo-model-s.svg';
import logoNoSmokingSvg from './logo-no-smoking.svg';
import logoNodejsSvg from './logo-nodejs.svg';
import logoNpmSvg from './logo-npm.svg';
import logoOctocatSvg from './logo-octocat.svg';
import logoPinterestSvg from './logo-pinterest.svg';
import logoPlaystationSvg from './logo-playstation.svg';
import logoPolymerSvg from './logo-polymer.svg';
import logoPythonSvg from './logo-python.svg';
import logoRedditSvg from './logo-reddit.svg';
import logoRssSvg from './logo-rss.svg';
import logoSassSvg from './logo-sass.svg';
import logoSkypeSvg from './logo-skype.svg';
import logoSlackSvg from './logo-slack.svg';
import logoSnapchatSvg from './logo-snapchat.svg';
import logoSteamSvg from './logo-steam.svg';
import logoTumblrSvg from './logo-tumblr.svg';
import logoTuxSvg from './logo-tux.svg';
import logoTwitchSvg from './logo-twitch.svg';
import logoTwitterSvg from './logo-twitter.svg';
import logoUsdSvg from './logo-usd.svg';
import logoVimeoSvg from './logo-vimeo.svg';
import logoVkSvg from './logo-vk.svg';
import logoWhatsappSvg from './logo-whatsapp.svg';
import logoWindowsSvg from './logo-windows.svg';
import logoWordpressSvg from './logo-wordpress.svg';
import logoXboxSvg from './logo-xbox.svg';
import logoXingSvg from './logo-xing.svg';
import logoYahooSvg from './logo-yahoo.svg';
import logoYenSvg from './logo-yen.svg';
import logoYoutubeSvg from './logo-youtube.svg';
import mdAddCircleOutlineSvg from './md-add-circle-outline.svg';
import mdAddCircleSvg from './md-add-circle.svg';
import mdAddSvg from './md-add.svg';
import mdAirplaneSvg from './md-airplane.svg';
import mdAlarmSvg from './md-alarm.svg';
import mdAlbumsSvg from './md-albums.svg';
import mdAlertSvg from './md-alert.svg';
import mdAmericanFootballSvg from './md-american-football.svg';
import mdAnalyticsSvg from './md-analytics.svg';
import mdApertureSvg from './md-aperture.svg';
import mdAppsSvg from './md-apps.svg';
import mdAppstoreSvg from './md-appstore.svg';
import mdArchiveSvg from './md-archive.svg';
import mdArrowBackSvg from './md-arrow-back.svg';
import mdArrowDownSvg from './md-arrow-down.svg';
import mdArrowDropdownCircleSvg from './md-arrow-dropdown-circle.svg';
import mdArrowDropdownSvg from './md-arrow-dropdown.svg';
import mdArrowDropleftCircleSvg from './md-arrow-dropleft-circle.svg';
import mdArrowDropleftSvg from './md-arrow-dropleft.svg';
import mdArrowDroprightCircleSvg from './md-arrow-dropright-circle.svg';
import mdArrowDroprightSvg from './md-arrow-dropright.svg';
import mdArrowDropupCircleSvg from './md-arrow-dropup-circle.svg';
import mdArrowDropupSvg from './md-arrow-dropup.svg';
import mdArrowForwardSvg from './md-arrow-forward.svg';
import mdArrowRoundBackSvg from './md-arrow-round-back.svg';
import mdArrowRoundDownSvg from './md-arrow-round-down.svg';
import mdArrowRoundForwardSvg from './md-arrow-round-forward.svg';
import mdArrowRoundUpSvg from './md-arrow-round-up.svg';
import mdArrowUpSvg from './md-arrow-up.svg';
import mdAtSvg from './md-at.svg';
import mdAttachSvg from './md-attach.svg';
import mdBackspaceSvg from './md-backspace.svg';
import mdBarcodeSvg from './md-barcode.svg';
import mdBaseballSvg from './md-baseball.svg';
import mdBasketSvg from './md-basket.svg';
import mdBasketballSvg from './md-basketball.svg';
import mdBatteryChargingSvg from './md-battery-charging.svg';
import mdBatteryDeadSvg from './md-battery-dead.svg';
import mdBatteryFullSvg from './md-battery-full.svg';
import mdBeakerSvg from './md-beaker.svg';
import mdBedSvg from './md-bed.svg';
import mdBeerSvg from './md-beer.svg';
import mdBicycleSvg from './md-bicycle.svg';
import mdBluetoothSvg from './md-bluetooth.svg';
import mdBoatSvg from './md-boat.svg';
import mdBodySvg from './md-body.svg';
import mdBonfireSvg from './md-bonfire.svg';
import mdBookSvg from './md-book.svg';
import mdBookmarkSvg from './md-bookmark.svg';
import mdBookmarksSvg from './md-bookmarks.svg';
import mdBowtieSvg from './md-bowtie.svg';
import mdBriefcaseSvg from './md-briefcase.svg';
import mdBrowsersSvg from './md-browsers.svg';
import mdBrushSvg from './md-brush.svg';
import mdBugSvg from './md-bug.svg';
import mdBuildSvg from './md-build.svg';
import mdBulbSvg from './md-bulb.svg';
import mdBusSvg from './md-bus.svg';
import mdBusinessSvg from './md-business.svg';
import mdCafeSvg from './md-cafe.svg';
import mdCalculatorSvg from './md-calculator.svg';
import mdCalendarSvg from './md-calendar.svg';
import mdCallSvg from './md-call.svg';
import mdCameraSvg from './md-camera.svg';
import mdCarSvg from './md-car.svg';
import mdCardSvg from './md-card.svg';
import mdCartSvg from './md-cart.svg';
import mdCashSvg from './md-cash.svg';
import mdCellularSvg from './md-cellular.svg';
import mdChatboxesSvg from './md-chatboxes.svg';
import mdChatbubblesSvg from './md-chatbubbles.svg';
import mdCheckboxOutlineSvg from './md-checkbox-outline.svg';
import mdCheckboxSvg from './md-checkbox.svg';
import mdCheckmarkCircleOutlineSvg from './md-checkmark-circle-outline.svg';
import mdCheckmarkCircleSvg from './md-checkmark-circle.svg';
import mdCheckmarkSvg from './md-checkmark.svg';
import mdClipboardSvg from './md-clipboard.svg';
import mdClockSvg from './md-clock.svg';
import mdCloseCircleOutlineSvg from './md-close-circle-outline.svg';
import mdCloseCircleSvg from './md-close-circle.svg';
import mdCloseSvg from './md-close.svg';
import mdCloudCircleSvg from './md-cloud-circle.svg';
import mdCloudDoneSvg from './md-cloud-done.svg';
import mdCloudDownloadSvg from './md-cloud-download.svg';
import mdCloudOutlineSvg from './md-cloud-outline.svg';
import mdCloudSvg from './md-cloud.svg';
import mdCloudUploadSvg from './md-cloud-upload.svg';
import mdCloudyNightSvg from './md-cloudy-night.svg';
import mdCloudySvg from './md-cloudy.svg';
import mdCodeDownloadSvg from './md-code-download.svg';
import mdCodeSvg from './md-code.svg';
import mdCodeWorkingSvg from './md-code-working.svg';
import mdCogSvg from './md-cog.svg';
import mdColorFillSvg from './md-color-fill.svg';
import mdColorFilterSvg from './md-color-filter.svg';
import mdColorPaletteSvg from './md-color-palette.svg';
import mdColorWandSvg from './md-color-wand.svg';
import mdCompassSvg from './md-compass.svg';
import mdConstructSvg from './md-construct.svg';
import mdContactSvg from './md-contact.svg';
import mdContactsSvg from './md-contacts.svg';
import mdContractSvg from './md-contract.svg';
import mdContrastSvg from './md-contrast.svg';
import mdCopySvg from './md-copy.svg';
import mdCreateSvg from './md-create.svg';
import mdCropSvg from './md-crop.svg';
import mdCubeSvg from './md-cube.svg';
import mdCutSvg from './md-cut.svg';
import mdDesktopSvg from './md-desktop.svg';
import mdDiscSvg from './md-disc.svg';
import mdDocumentSvg from './md-document.svg';
import mdDoneAllSvg from './md-done-all.svg';
import mdDownloadSvg from './md-download.svg';
import mdEaselSvg from './md-easel.svg';
import mdEggSvg from './md-egg.svg';
import mdExitSvg from './md-exit.svg';
import mdExpandSvg from './md-expand.svg';
import mdEyeOffSvg from './md-eye-off.svg';
import mdEyeSvg from './md-eye.svg';
import mdFastforwardSvg from './md-fastforward.svg';
import mdFemaleSvg from './md-female.svg';
import mdFilingSvg from './md-filing.svg';
import mdFilmSvg from './md-film.svg';
import mdFingerPrintSvg from './md-finger-print.svg';
import mdFitnessSvg from './md-fitness.svg';
import mdFlagSvg from './md-flag.svg';
import mdFlameSvg from './md-flame.svg';
import mdFlashOffSvg from './md-flash-off.svg';
import mdFlashSvg from './md-flash.svg';
import mdFlashlightSvg from './md-flashlight.svg';
import mdFlaskSvg from './md-flask.svg';
import mdFlowerSvg from './md-flower.svg';
import mdFolderOpenSvg from './md-folder-open.svg';
import mdFolderSvg from './md-folder.svg';
import mdFootballSvg from './md-football.svg';
import mdFunnelSvg from './md-funnel.svg';
import mdGiftSvg from './md-gift.svg';
import mdGitBranchSvg from './md-git-branch.svg';
import mdGitCommitSvg from './md-git-commit.svg';
import mdGitCompareSvg from './md-git-compare.svg';
import mdGitMergeSvg from './md-git-merge.svg';
import mdGitNetworkSvg from './md-git-network.svg';
import mdGitPullRequestSvg from './md-git-pull-request.svg';
import mdGlassesSvg from './md-glasses.svg';
import mdGlobeSvg from './md-globe.svg';
import mdGridSvg from './md-grid.svg';
import mdHammerSvg from './md-hammer.svg';
import mdHandSvg from './md-hand.svg';
import mdHappySvg from './md-happy.svg';
import mdHeadsetSvg from './md-headset.svg';
import mdHeartDislikeSvg from './md-heart-dislike.svg';
import mdHeartEmptySvg from './md-heart-empty.svg';
import mdHeartHalfSvg from './md-heart-half.svg';
import mdHeartSvg from './md-heart.svg';
import mdHelpBuoySvg from './md-help-buoy.svg';
import mdHelpCircleOutlineSvg from './md-help-circle-outline.svg';
import mdHelpCircleSvg from './md-help-circle.svg';
import mdHelpSvg from './md-help.svg';
import mdHomeSvg from './md-home.svg';
import mdHourglassSvg from './md-hourglass.svg';
import mdIceCreamSvg from './md-ice-cream.svg';
import mdImageSvg from './md-image.svg';
import mdImagesSvg from './md-images.svg';
import mdInfiniteSvg from './md-infinite.svg';
import mdInformationCircleOutlineSvg from './md-information-circle-outline.svg';
import mdInformationCircleSvg from './md-information-circle.svg';
import mdInformationSvg from './md-information.svg';
import mdJetSvg from './md-jet.svg';
import mdJournalSvg from './md-journal.svg';
import mdKeySvg from './md-key.svg';
import mdKeypadSvg from './md-keypad.svg';
import mdLaptopSvg from './md-laptop.svg';
import mdLeafSvg from './md-leaf.svg';
import mdLinkSvg from './md-link.svg';
import mdListBoxSvg from './md-list-box.svg';
import mdListSvg from './md-list.svg';
import mdLocateSvg from './md-locate.svg';
import mdLockSvg from './md-lock.svg';
import mdLogInSvg from './md-log-in.svg';
import mdLogOutSvg from './md-log-out.svg';
import mdMagnetSvg from './md-magnet.svg';
import mdMailOpenSvg from './md-mail-open.svg';
import mdMailSvg from './md-mail.svg';
import mdMailUnreadSvg from './md-mail-unread.svg';
import mdMaleSvg from './md-male.svg';
import mdManSvg from './md-man.svg';
import mdMapSvg from './md-map.svg';
import mdMedalSvg from './md-medal.svg';
import mdMedicalSvg from './md-medical.svg';
import mdMedkitSvg from './md-medkit.svg';
import mdMegaphoneSvg from './md-megaphone.svg';
import mdMenuSvg from './md-menu.svg';
import mdMicOffSvg from './md-mic-off.svg';
import mdMicSvg from './md-mic.svg';
import mdMicrophoneSvg from './md-microphone.svg';
import mdMoonSvg from './md-moon.svg';
import mdMoreSvg from './md-more.svg';
import mdMoveSvg from './md-move.svg';
import mdMusicalNoteSvg from './md-musical-note.svg';
import mdMusicalNotesSvg from './md-musical-notes.svg';
import mdNavigateSvg from './md-navigate.svg';
import mdNotificationsOffSvg from './md-notifications-off.svg';
import mdNotificationsOutlineSvg from './md-notifications-outline.svg';
import mdNotificationsSvg from './md-notifications.svg';
import mdNuclearSvg from './md-nuclear.svg';
import mdNutritionSvg from './md-nutrition.svg';
import mdOpenSvg from './md-open.svg';
import mdOptionsSvg from './md-options.svg';
import mdOutletSvg from './md-outlet.svg';
import mdPaperPlaneSvg from './md-paper-plane.svg';
import mdPaperSvg from './md-paper.svg';
import mdPartlySunnySvg from './md-partly-sunny.svg';
import mdPauseSvg from './md-pause.svg';
import mdPawSvg from './md-paw.svg';
import mdPeopleSvg from './md-people.svg';
import mdPersonAddSvg from './md-person-add.svg';
import mdPersonSvg from './md-person.svg';
import mdPhoneLandscapeSvg from './md-phone-landscape.svg';
import mdPhonePortraitSvg from './md-phone-portrait.svg';
import mdPhotosSvg from './md-photos.svg';
import mdPieSvg from './md-pie.svg';
import mdPinSvg from './md-pin.svg';
import mdPintSvg from './md-pint.svg';
import mdPizzaSvg from './md-pizza.svg';
import mdPlanetSvg from './md-planet.svg';
import mdPlayCircleSvg from './md-play-circle.svg';
import mdPlaySvg from './md-play.svg';
import mdPodiumSvg from './md-podium.svg';
import mdPowerSvg from './md-power.svg';
import mdPricetagSvg from './md-pricetag.svg';
import mdPricetagsSvg from './md-pricetags.svg';
import mdPrintSvg from './md-print.svg';
import mdPulseSvg from './md-pulse.svg';
import mdQrScannerSvg from './md-qr-scanner.svg';
import mdQuoteSvg from './md-quote.svg';
import mdRadioButtonOffSvg from './md-radio-button-off.svg';
import mdRadioButtonOnSvg from './md-radio-button-on.svg';
import mdRadioSvg from './md-radio.svg';
import mdRainySvg from './md-rainy.svg';
import mdRecordingSvg from './md-recording.svg';
import mdRedoSvg from './md-redo.svg';
import mdRefreshCircleSvg from './md-refresh-circle.svg';
import mdRefreshSvg from './md-refresh.svg';
import mdRemoveCircleOutlineSvg from './md-remove-circle-outline.svg';
import mdRemoveCircleSvg from './md-remove-circle.svg';
import mdRemoveSvg from './md-remove.svg';
import mdReorderSvg from './md-reorder.svg';
import mdRepeatSvg from './md-repeat.svg';
import mdResizeSvg from './md-resize.svg';
import mdRestaurantSvg from './md-restaurant.svg';
import mdReturnLeftSvg from './md-return-left.svg';
import mdReturnRightSvg from './md-return-right.svg';
import mdReverseCameraSvg from './md-reverse-camera.svg';
import mdRewindSvg from './md-rewind.svg';
import mdRibbonSvg from './md-ribbon.svg';
import mdRocketSvg from './md-rocket.svg';
import mdRoseSvg from './md-rose.svg';
import mdSadSvg from './md-sad.svg';
import mdSaveSvg from './md-save.svg';
import mdSchoolSvg from './md-school.svg';
import mdSearchSvg from './md-search.svg';
import mdSendSvg from './md-send.svg';
import mdSettingsSvg from './md-settings.svg';
import mdShareAltSvg from './md-share-alt.svg';
import mdShareSvg from './md-share.svg';
import mdShirtSvg from './md-shirt.svg';
import mdShuffleSvg from './md-shuffle.svg';
import mdSkipBackwardSvg from './md-skip-backward.svg';
import mdSkipForwardSvg from './md-skip-forward.svg';
import mdSnowSvg from './md-snow.svg';
import mdSpeedometerSvg from './md-speedometer.svg';
import mdSquareOutlineSvg from './md-square-outline.svg';
import mdSquareSvg from './md-square.svg';
import mdStarHalfSvg from './md-star-half.svg';
import mdStarOutlineSvg from './md-star-outline.svg';
import mdStarSvg from './md-star.svg';
import mdStatsSvg from './md-stats.svg';
import mdStopwatchSvg from './md-stopwatch.svg';
import mdSubwaySvg from './md-subway.svg';
import mdSunnySvg from './md-sunny.svg';
import mdSwapSvg from './md-swap.svg';
import mdSwitchSvg from './md-switch.svg';
import mdSyncSvg from './md-sync.svg';
import mdTabletLandscapeSvg from './md-tablet-landscape.svg';
import mdTabletPortraitSvg from './md-tablet-portrait.svg';
import mdTennisballSvg from './md-tennisball.svg';
import mdTextSvg from './md-text.svg';
import mdThermometerSvg from './md-thermometer.svg';
import mdThumbsDownSvg from './md-thumbs-down.svg';
import mdThumbsUpSvg from './md-thumbs-up.svg';
import mdThunderstormSvg from './md-thunderstorm.svg';
import mdTimeSvg from './md-time.svg';
import mdTimerSvg from './md-timer.svg';
import mdTodaySvg from './md-today.svg';
import mdTrainSvg from './md-train.svg';
import mdTransgenderSvg from './md-transgender.svg';
import mdTrashSvg from './md-trash.svg';
import mdTrendingDownSvg from './md-trending-down.svg';
import mdTrendingUpSvg from './md-trending-up.svg';
import mdTrophySvg from './md-trophy.svg';
import mdTvSvg from './md-tv.svg';
import mdUmbrellaSvg from './md-umbrella.svg';
import mdUndoSvg from './md-undo.svg';
import mdUnlockSvg from './md-unlock.svg';
import mdVideocamSvg from './md-videocam.svg';
import mdVolumeHighSvg from './md-volume-high.svg';
import mdVolumeLowSvg from './md-volume-low.svg';
import mdVolumeMuteSvg from './md-volume-mute.svg';
import mdVolumeOffSvg from './md-volume-off.svg';
import mdWalkSvg from './md-walk.svg';
import mdWalletSvg from './md-wallet.svg';
import mdWarningSvg from './md-warning.svg';
import mdWatchSvg from './md-watch.svg';
import mdWaterSvg from './md-water.svg';
import mdWifiSvg from './md-wifi.svg';
import mdWineSvg from './md-wine.svg';
import mdWomanSvg from './md-woman.svg';
export var add = {
  ios: iosAddSvg,
  md: mdAddSvg
};
export var addCircle = {
  ios: iosAddCircleSvg,
  md: mdAddCircleSvg
};
export var addCircleOutline = {
  ios: iosAddCircleOutlineSvg,
  md: mdAddCircleOutlineSvg
};
export var airplane = {
  ios: iosAirplaneSvg,
  md: mdAirplaneSvg
};
export var alarm = {
  ios: iosAlarmSvg,
  md: mdAlarmSvg
};
export var albums = {
  ios: iosAlbumsSvg,
  md: mdAlbumsSvg
};
export var alert = {
  ios: iosAlertSvg,
  md: mdAlertSvg
};
export var americanFootball = {
  ios: iosAmericanFootballSvg,
  md: mdAmericanFootballSvg
};
export var analytics = {
  ios: iosAnalyticsSvg,
  md: mdAnalyticsSvg
};
export var aperture = {
  ios: iosApertureSvg,
  md: mdApertureSvg
};
export var apps = {
  ios: iosAppsSvg,
  md: mdAppsSvg
};
export var appstore = {
  ios: iosAppstoreSvg,
  md: mdAppstoreSvg
};
export var archive = {
  ios: iosArchiveSvg,
  md: mdArchiveSvg
};
export var arrowBack = {
  ios: iosArrowBackSvg,
  md: mdArrowBackSvg
};
export var arrowDown = {
  ios: iosArrowDownSvg,
  md: mdArrowDownSvg
};
export var arrowDropdown = {
  ios: iosArrowDropdownSvg,
  md: mdArrowDropdownSvg
};
export var arrowDropdownCircle = {
  ios: iosArrowDropdownCircleSvg,
  md: mdArrowDropdownCircleSvg
};
export var arrowDropleft = {
  ios: iosArrowDropleftSvg,
  md: mdArrowDropleftSvg
};
export var arrowDropleftCircle = {
  ios: iosArrowDropleftCircleSvg,
  md: mdArrowDropleftCircleSvg
};
export var arrowDropright = {
  ios: iosArrowDroprightSvg,
  md: mdArrowDroprightSvg
};
export var arrowDroprightCircle = {
  ios: iosArrowDroprightCircleSvg,
  md: mdArrowDroprightCircleSvg
};
export var arrowDropup = {
  ios: iosArrowDropupSvg,
  md: mdArrowDropupSvg
};
export var arrowDropupCircle = {
  ios: iosArrowDropupCircleSvg,
  md: mdArrowDropupCircleSvg
};
export var arrowForward = {
  ios: iosArrowForwardSvg,
  md: mdArrowForwardSvg
};
export var arrowRoundBack = {
  ios: iosArrowRoundBackSvg,
  md: mdArrowRoundBackSvg
};
export var arrowRoundDown = {
  ios: iosArrowRoundDownSvg,
  md: mdArrowRoundDownSvg
};
export var arrowRoundForward = {
  ios: iosArrowRoundForwardSvg,
  md: mdArrowRoundForwardSvg
};
export var arrowRoundUp = {
  ios: iosArrowRoundUpSvg,
  md: mdArrowRoundUpSvg
};
export var arrowUp = {
  ios: iosArrowUpSvg,
  md: mdArrowUpSvg
};
export var at = {
  ios: iosAtSvg,
  md: mdAtSvg
};
export var attach = {
  ios: iosAttachSvg,
  md: mdAttachSvg
};
export var backspace = {
  ios: iosBackspaceSvg,
  md: mdBackspaceSvg
};
export var barcode = {
  ios: iosBarcodeSvg,
  md: mdBarcodeSvg
};
export var baseball = {
  ios: iosBaseballSvg,
  md: mdBaseballSvg
};
export var basket = {
  ios: iosBasketSvg,
  md: mdBasketSvg
};
export var basketball = {
  ios: iosBasketballSvg,
  md: mdBasketballSvg
};
export var batteryCharging = {
  ios: iosBatteryChargingSvg,
  md: mdBatteryChargingSvg
};
export var batteryDead = {
  ios: iosBatteryDeadSvg,
  md: mdBatteryDeadSvg
};
export var batteryFull = {
  ios: iosBatteryFullSvg,
  md: mdBatteryFullSvg
};
export var beaker = {
  ios: iosBeakerSvg,
  md: mdBeakerSvg
};
export var bed = {
  ios: iosBedSvg,
  md: mdBedSvg
};
export var beer = {
  ios: iosBeerSvg,
  md: mdBeerSvg
};
export var bicycle = {
  ios: iosBicycleSvg,
  md: mdBicycleSvg
};
export var bluetooth = {
  ios: iosBluetoothSvg,
  md: mdBluetoothSvg
};
export var boat = {
  ios: iosBoatSvg,
  md: mdBoatSvg
};
export var body = {
  ios: iosBodySvg,
  md: mdBodySvg
};
export var bonfire = {
  ios: iosBonfireSvg,
  md: mdBonfireSvg
};
export var book = {
  ios: iosBookSvg,
  md: mdBookSvg
};
export var bookmark = {
  ios: iosBookmarkSvg,
  md: mdBookmarkSvg
};
export var bookmarks = {
  ios: iosBookmarksSvg,
  md: mdBookmarksSvg
};
export var bowtie = {
  ios: iosBowtieSvg,
  md: mdBowtieSvg
};
export var briefcase = {
  ios: iosBriefcaseSvg,
  md: mdBriefcaseSvg
};
export var browsers = {
  ios: iosBrowsersSvg,
  md: mdBrowsersSvg
};
export var brush = {
  ios: iosBrushSvg,
  md: mdBrushSvg
};
export var bug = {
  ios: iosBugSvg,
  md: mdBugSvg
};
export var build = {
  ios: iosBuildSvg,
  md: mdBuildSvg
};
export var bulb = {
  ios: iosBulbSvg,
  md: mdBulbSvg
};
export var bus = {
  ios: iosBusSvg,
  md: mdBusSvg
};
export var business = {
  ios: iosBusinessSvg,
  md: mdBusinessSvg
};
export var cafe = {
  ios: iosCafeSvg,
  md: mdCafeSvg
};
export var calculator = {
  ios: iosCalculatorSvg,
  md: mdCalculatorSvg
};
export var calendar = {
  ios: iosCalendarSvg,
  md: mdCalendarSvg
};
export var call = {
  ios: iosCallSvg,
  md: mdCallSvg
};
export var camera = {
  ios: iosCameraSvg,
  md: mdCameraSvg
};
export var car = {
  ios: iosCarSvg,
  md: mdCarSvg
};
export var card = {
  ios: iosCardSvg,
  md: mdCardSvg
};
export var cart = {
  ios: iosCartSvg,
  md: mdCartSvg
};
export var cash = {
  ios: iosCashSvg,
  md: mdCashSvg
};
export var cellular = {
  ios: iosCellularSvg,
  md: mdCellularSvg
};
export var chatboxes = {
  ios: iosChatboxesSvg,
  md: mdChatboxesSvg
};
export var chatbubbles = {
  ios: iosChatbubblesSvg,
  md: mdChatbubblesSvg
};
export var checkbox = {
  ios: iosCheckboxSvg,
  md: mdCheckboxSvg
};
export var checkboxOutline = {
  ios: iosCheckboxOutlineSvg,
  md: mdCheckboxOutlineSvg
};
export var checkmark = {
  ios: iosCheckmarkSvg,
  md: mdCheckmarkSvg
};
export var checkmarkCircle = {
  ios: iosCheckmarkCircleSvg,
  md: mdCheckmarkCircleSvg
};
export var checkmarkCircleOutline = {
  ios: iosCheckmarkCircleOutlineSvg,
  md: mdCheckmarkCircleOutlineSvg
};
export var clipboard = {
  ios: iosClipboardSvg,
  md: mdClipboardSvg
};
export var clock = {
  ios: iosClockSvg,
  md: mdClockSvg
};
export var close = {
  ios: iosCloseSvg,
  md: mdCloseSvg
};
export var closeCircle = {
  ios: iosCloseCircleSvg,
  md: mdCloseCircleSvg
};
export var closeCircleOutline = {
  ios: iosCloseCircleOutlineSvg,
  md: mdCloseCircleOutlineSvg
};
export var cloud = {
  ios: iosCloudSvg,
  md: mdCloudSvg
};
export var cloudCircle = {
  ios: iosCloudCircleSvg,
  md: mdCloudCircleSvg
};
export var cloudDone = {
  ios: iosCloudDoneSvg,
  md: mdCloudDoneSvg
};
export var cloudDownload = {
  ios: iosCloudDownloadSvg,
  md: mdCloudDownloadSvg
};
export var cloudOutline = {
  ios: iosCloudOutlineSvg,
  md: mdCloudOutlineSvg
};
export var cloudUpload = {
  ios: iosCloudUploadSvg,
  md: mdCloudUploadSvg
};
export var cloudy = {
  ios: iosCloudySvg,
  md: mdCloudySvg
};
export var cloudyNight = {
  ios: iosCloudyNightSvg,
  md: mdCloudyNightSvg
};
export var code = {
  ios: iosCodeSvg,
  md: mdCodeSvg
};
export var codeDownload = {
  ios: iosCodeDownloadSvg,
  md: mdCodeDownloadSvg
};
export var codeWorking = {
  ios: iosCodeWorkingSvg,
  md: mdCodeWorkingSvg
};
export var cog = {
  ios: iosCogSvg,
  md: mdCogSvg
};
export var colorFill = {
  ios: iosColorFillSvg,
  md: mdColorFillSvg
};
export var colorFilter = {
  ios: iosColorFilterSvg,
  md: mdColorFilterSvg
};
export var colorPalette = {
  ios: iosColorPaletteSvg,
  md: mdColorPaletteSvg
};
export var colorWand = {
  ios: iosColorWandSvg,
  md: mdColorWandSvg
};
export var compass = {
  ios: iosCompassSvg,
  md: mdCompassSvg
};
export var construct = {
  ios: iosConstructSvg,
  md: mdConstructSvg
};
export var contact = {
  ios: iosContactSvg,
  md: mdContactSvg
};
export var contacts = {
  ios: iosContactsSvg,
  md: mdContactsSvg
};
export var contract = {
  ios: iosContractSvg,
  md: mdContractSvg
};
export var contrast = {
  ios: iosContrastSvg,
  md: mdContrastSvg
};
export var copy = {
  ios: iosCopySvg,
  md: mdCopySvg
};
export var create = {
  ios: iosCreateSvg,
  md: mdCreateSvg
};
export var crop = {
  ios: iosCropSvg,
  md: mdCropSvg
};
export var cube = {
  ios: iosCubeSvg,
  md: mdCubeSvg
};
export var cut = {
  ios: iosCutSvg,
  md: mdCutSvg
};
export var desktop = {
  ios: iosDesktopSvg,
  md: mdDesktopSvg
};
export var disc = {
  ios: iosDiscSvg,
  md: mdDiscSvg
};
export var document = {
  ios: iosDocumentSvg,
  md: mdDocumentSvg
};
export var doneAll = {
  ios: iosDoneAllSvg,
  md: mdDoneAllSvg
};
export var download = {
  ios: iosDownloadSvg,
  md: mdDownloadSvg
};
export var easel = {
  ios: iosEaselSvg,
  md: mdEaselSvg
};
export var egg = {
  ios: iosEggSvg,
  md: mdEggSvg
};
export var exit = {
  ios: iosExitSvg,
  md: mdExitSvg
};
export var expand = {
  ios: iosExpandSvg,
  md: mdExpandSvg
};
export var eye = {
  ios: iosEyeSvg,
  md: mdEyeSvg
};
export var eyeOff = {
  ios: iosEyeOffSvg,
  md: mdEyeOffSvg
};
export var fastforward = {
  ios: iosFastforwardSvg,
  md: mdFastforwardSvg
};
export var female = {
  ios: iosFemaleSvg,
  md: mdFemaleSvg
};
export var filing = {
  ios: iosFilingSvg,
  md: mdFilingSvg
};
export var film = {
  ios: iosFilmSvg,
  md: mdFilmSvg
};
export var fingerPrint = {
  ios: iosFingerPrintSvg,
  md: mdFingerPrintSvg
};
export var fitness = {
  ios: iosFitnessSvg,
  md: mdFitnessSvg
};
export var flag = {
  ios: iosFlagSvg,
  md: mdFlagSvg
};
export var flame = {
  ios: iosFlameSvg,
  md: mdFlameSvg
};
export var flash = {
  ios: iosFlashSvg,
  md: mdFlashSvg
};
export var flashOff = {
  ios: iosFlashOffSvg,
  md: mdFlashOffSvg
};
export var flashlight = {
  ios: iosFlashlightSvg,
  md: mdFlashlightSvg
};
export var flask = {
  ios: iosFlaskSvg,
  md: mdFlaskSvg
};
export var flower = {
  ios: iosFlowerSvg,
  md: mdFlowerSvg
};
export var folder = {
  ios: iosFolderSvg,
  md: mdFolderSvg
};
export var folderOpen = {
  ios: iosFolderOpenSvg,
  md: mdFolderOpenSvg
};
export var football = {
  ios: iosFootballSvg,
  md: mdFootballSvg
};
export var funnel = {
  ios: iosFunnelSvg,
  md: mdFunnelSvg
};
export var gift = {
  ios: iosGiftSvg,
  md: mdGiftSvg
};
export var gitBranch = {
  ios: iosGitBranchSvg,
  md: mdGitBranchSvg
};
export var gitCommit = {
  ios: iosGitCommitSvg,
  md: mdGitCommitSvg
};
export var gitCompare = {
  ios: iosGitCompareSvg,
  md: mdGitCompareSvg
};
export var gitMerge = {
  ios: iosGitMergeSvg,
  md: mdGitMergeSvg
};
export var gitNetwork = {
  ios: iosGitNetworkSvg,
  md: mdGitNetworkSvg
};
export var gitPullRequest = {
  ios: iosGitPullRequestSvg,
  md: mdGitPullRequestSvg
};
export var glasses = {
  ios: iosGlassesSvg,
  md: mdGlassesSvg
};
export var globe = {
  ios: iosGlobeSvg,
  md: mdGlobeSvg
};
export var grid = {
  ios: iosGridSvg,
  md: mdGridSvg
};
export var hammer = {
  ios: iosHammerSvg,
  md: mdHammerSvg
};
export var hand = {
  ios: iosHandSvg,
  md: mdHandSvg
};
export var happy = {
  ios: iosHappySvg,
  md: mdHappySvg
};
export var headset = {
  ios: iosHeadsetSvg,
  md: mdHeadsetSvg
};
export var heart = {
  ios: iosHeartSvg,
  md: mdHeartSvg
};
export var heartDislike = {
  ios: iosHeartDislikeSvg,
  md: mdHeartDislikeSvg
};
export var heartEmpty = {
  ios: iosHeartEmptySvg,
  md: mdHeartEmptySvg
};
export var heartHalf = {
  ios: iosHeartHalfSvg,
  md: mdHeartHalfSvg
};
export var help = {
  ios: iosHelpSvg,
  md: mdHelpSvg
};
export var helpBuoy = {
  ios: iosHelpBuoySvg,
  md: mdHelpBuoySvg
};
export var helpCircle = {
  ios: iosHelpCircleSvg,
  md: mdHelpCircleSvg
};
export var helpCircleOutline = {
  ios: iosHelpCircleOutlineSvg,
  md: mdHelpCircleOutlineSvg
};
export var home = {
  ios: iosHomeSvg,
  md: mdHomeSvg
};
export var hourglass = {
  ios: iosHourglassSvg,
  md: mdHourglassSvg
};
export var iceCream = {
  ios: iosIceCreamSvg,
  md: mdIceCreamSvg
};
export var image = {
  ios: iosImageSvg,
  md: mdImageSvg
};
export var images = {
  ios: iosImagesSvg,
  md: mdImagesSvg
};
export var infinite = {
  ios: iosInfiniteSvg,
  md: mdInfiniteSvg
};
export var information = {
  ios: iosInformationSvg,
  md: mdInformationSvg
};
export var informationCircle = {
  ios: iosInformationCircleSvg,
  md: mdInformationCircleSvg
};
export var informationCircleOutline = {
  ios: iosInformationCircleOutlineSvg,
  md: mdInformationCircleOutlineSvg
};
export var jet = {
  ios: iosJetSvg,
  md: mdJetSvg
};
export var journal = {
  ios: iosJournalSvg,
  md: mdJournalSvg
};
export var key = {
  ios: iosKeySvg,
  md: mdKeySvg
};
export var keypad = {
  ios: iosKeypadSvg,
  md: mdKeypadSvg
};
export var laptop = {
  ios: iosLaptopSvg,
  md: mdLaptopSvg
};
export var leaf = {
  ios: iosLeafSvg,
  md: mdLeafSvg
};
export var link = {
  ios: iosLinkSvg,
  md: mdLinkSvg
};
export var list = {
  ios: iosListSvg,
  md: mdListSvg
};
export var listBox = {
  ios: iosListBoxSvg,
  md: mdListBoxSvg
};
export var locate = {
  ios: iosLocateSvg,
  md: mdLocateSvg
};
export var lock = {
  ios: iosLockSvg,
  md: mdLockSvg
};
export var logIn = {
  ios: iosLogInSvg,
  md: mdLogInSvg
};
export var logOut = {
  ios: iosLogOutSvg,
  md: mdLogOutSvg
};
export var logoAndroid = logoAndroidSvg;
export var logoAngular = logoAngularSvg;
export var logoApple = logoAppleSvg;
export var logoBitbucket = logoBitbucketSvg;
export var logoBitcoin = logoBitcoinSvg;
export var logoBuffer = logoBufferSvg;
export var logoChrome = logoChromeSvg;
export var logoClosedCaptioning = logoClosedCaptioningSvg;
export var logoCodepen = logoCodepenSvg;
export var logoCss3 = logoCss3Svg;
export var logoDesignernews = logoDesignernewsSvg;
export var logoDribbble = logoDribbbleSvg;
export var logoDropbox = logoDropboxSvg;
export var logoEuro = logoEuroSvg;
export var logoFacebook = logoFacebookSvg;
export var logoFlickr = logoFlickrSvg;
export var logoFoursquare = logoFoursquareSvg;
export var logoFreebsdDevil = logoFreebsdDevilSvg;
export var logoGameControllerA = logoGameControllerASvg;
export var logoGameControllerB = logoGameControllerBSvg;
export var logoGithub = logoGithubSvg;
export var logoGoogle = logoGoogleSvg;
export var logoGoogleplus = logoGoogleplusSvg;
export var logoHackernews = logoHackernewsSvg;
export var logoHtml5 = logoHtml5Svg;
export var logoInstagram = logoInstagramSvg;
export var logoIonic = logoIonicSvg;
export var logoIonitron = logoIonitronSvg;
export var logoJavascript = logoJavascriptSvg;
export var logoLinkedin = logoLinkedinSvg;
export var logoMarkdown = logoMarkdownSvg;
export var logoModelS = logoModelSSvg;
export var logoNoSmoking = logoNoSmokingSvg;
export var logoNodejs = logoNodejsSvg;
export var logoNpm = logoNpmSvg;
export var logoOctocat = logoOctocatSvg;
export var logoPinterest = logoPinterestSvg;
export var logoPlaystation = logoPlaystationSvg;
export var logoPolymer = logoPolymerSvg;
export var logoPython = logoPythonSvg;
export var logoReddit = logoRedditSvg;
export var logoRss = logoRssSvg;
export var logoSass = logoSassSvg;
export var logoSkype = logoSkypeSvg;
export var logoSlack = logoSlackSvg;
export var logoSnapchat = logoSnapchatSvg;
export var logoSteam = logoSteamSvg;
export var logoTumblr = logoTumblrSvg;
export var logoTux = logoTuxSvg;
export var logoTwitch = logoTwitchSvg;
export var logoTwitter = logoTwitterSvg;
export var logoUsd = logoUsdSvg;
export var logoVimeo = logoVimeoSvg;
export var logoVk = logoVkSvg;
export var logoWhatsapp = logoWhatsappSvg;
export var logoWindows = logoWindowsSvg;
export var logoWordpress = logoWordpressSvg;
export var logoXbox = logoXboxSvg;
export var logoXing = logoXingSvg;
export var logoYahoo = logoYahooSvg;
export var logoYen = logoYenSvg;
export var logoYoutube = logoYoutubeSvg;
export var magnet = {
  ios: iosMagnetSvg,
  md: mdMagnetSvg
};
export var mail = {
  ios: iosMailSvg,
  md: mdMailSvg
};
export var mailOpen = {
  ios: iosMailOpenSvg,
  md: mdMailOpenSvg
};
export var mailUnread = {
  ios: iosMailUnreadSvg,
  md: mdMailUnreadSvg
};
export var male = {
  ios: iosMaleSvg,
  md: mdMaleSvg
};
export var man = {
  ios: iosManSvg,
  md: mdManSvg
};
export var map = {
  ios: iosMapSvg,
  md: mdMapSvg
};
export var medal = {
  ios: iosMedalSvg,
  md: mdMedalSvg
};
export var medical = {
  ios: iosMedicalSvg,
  md: mdMedicalSvg
};
export var medkit = {
  ios: iosMedkitSvg,
  md: mdMedkitSvg
};
export var megaphone = {
  ios: iosMegaphoneSvg,
  md: mdMegaphoneSvg
};
export var menu = {
  ios: iosMenuSvg,
  md: mdMenuSvg
};
export var mic = {
  ios: iosMicSvg,
  md: mdMicSvg
};
export var micOff = {
  ios: iosMicOffSvg,
  md: mdMicOffSvg
};
export var microphone = {
  ios: iosMicrophoneSvg,
  md: mdMicrophoneSvg
};
export var moon = {
  ios: iosMoonSvg,
  md: mdMoonSvg
};
export var more = {
  ios: iosMoreSvg,
  md: mdMoreSvg
};
export var move = {
  ios: iosMoveSvg,
  md: mdMoveSvg
};
export var musicalNote = {
  ios: iosMusicalNoteSvg,
  md: mdMusicalNoteSvg
};
export var musicalNotes = {
  ios: iosMusicalNotesSvg,
  md: mdMusicalNotesSvg
};
export var navigate = {
  ios: iosNavigateSvg,
  md: mdNavigateSvg
};
export var notifications = {
  ios: iosNotificationsSvg,
  md: mdNotificationsSvg
};
export var notificationsOff = {
  ios: iosNotificationsOffSvg,
  md: mdNotificationsOffSvg
};
export var notificationsOutline = {
  ios: iosNotificationsOutlineSvg,
  md: mdNotificationsOutlineSvg
};
export var nuclear = {
  ios: iosNuclearSvg,
  md: mdNuclearSvg
};
export var nutrition = {
  ios: iosNutritionSvg,
  md: mdNutritionSvg
};
export var open = {
  ios: iosOpenSvg,
  md: mdOpenSvg
};
export var options = {
  ios: iosOptionsSvg,
  md: mdOptionsSvg
};
export var outlet = {
  ios: iosOutletSvg,
  md: mdOutletSvg
};
export var paper = {
  ios: iosPaperSvg,
  md: mdPaperSvg
};
export var paperPlane = {
  ios: iosPaperPlaneSvg,
  md: mdPaperPlaneSvg
};
export var partlySunny = {
  ios: iosPartlySunnySvg,
  md: mdPartlySunnySvg
};
export var pause = {
  ios: iosPauseSvg,
  md: mdPauseSvg
};
export var paw = {
  ios: iosPawSvg,
  md: mdPawSvg
};
export var people = {
  ios: iosPeopleSvg,
  md: mdPeopleSvg
};
export var person = {
  ios: iosPersonSvg,
  md: mdPersonSvg
};
export var personAdd = {
  ios: iosPersonAddSvg,
  md: mdPersonAddSvg
};
export var phoneLandscape = {
  ios: iosPhoneLandscapeSvg,
  md: mdPhoneLandscapeSvg
};
export var phonePortrait = {
  ios: iosPhonePortraitSvg,
  md: mdPhonePortraitSvg
};
export var photos = {
  ios: iosPhotosSvg,
  md: mdPhotosSvg
};
export var pie = {
  ios: iosPieSvg,
  md: mdPieSvg
};
export var pin = {
  ios: iosPinSvg,
  md: mdPinSvg
};
export var pint = {
  ios: iosPintSvg,
  md: mdPintSvg
};
export var pizza = {
  ios: iosPizzaSvg,
  md: mdPizzaSvg
};
export var planet = {
  ios: iosPlanetSvg,
  md: mdPlanetSvg
};
export var play = {
  ios: iosPlaySvg,
  md: mdPlaySvg
};
export var playCircle = {
  ios: iosPlayCircleSvg,
  md: mdPlayCircleSvg
};
export var podium = {
  ios: iosPodiumSvg,
  md: mdPodiumSvg
};
export var power = {
  ios: iosPowerSvg,
  md: mdPowerSvg
};
export var pricetag = {
  ios: iosPricetagSvg,
  md: mdPricetagSvg
};
export var pricetags = {
  ios: iosPricetagsSvg,
  md: mdPricetagsSvg
};
export var print = {
  ios: iosPrintSvg,
  md: mdPrintSvg
};
export var pulse = {
  ios: iosPulseSvg,
  md: mdPulseSvg
};
export var qrScanner = {
  ios: iosQrScannerSvg,
  md: mdQrScannerSvg
};
export var quote = {
  ios: iosQuoteSvg,
  md: mdQuoteSvg
};
export var radio = {
  ios: iosRadioSvg,
  md: mdRadioSvg
};
export var radioButtonOff = {
  ios: iosRadioButtonOffSvg,
  md: mdRadioButtonOffSvg
};
export var radioButtonOn = {
  ios: iosRadioButtonOnSvg,
  md: mdRadioButtonOnSvg
};
export var rainy = {
  ios: iosRainySvg,
  md: mdRainySvg
};
export var recording = {
  ios: iosRecordingSvg,
  md: mdRecordingSvg
};
export var redo = {
  ios: iosRedoSvg,
  md: mdRedoSvg
};
export var refresh = {
  ios: iosRefreshSvg,
  md: mdRefreshSvg
};
export var refreshCircle = {
  ios: iosRefreshCircleSvg,
  md: mdRefreshCircleSvg
};
export var remove = {
  ios: iosRemoveSvg,
  md: mdRemoveSvg
};
export var removeCircle = {
  ios: iosRemoveCircleSvg,
  md: mdRemoveCircleSvg
};
export var removeCircleOutline = {
  ios: iosRemoveCircleOutlineSvg,
  md: mdRemoveCircleOutlineSvg
};
export var reorder = {
  ios: iosReorderSvg,
  md: mdReorderSvg
};
export var repeat = {
  ios: iosRepeatSvg,
  md: mdRepeatSvg
};
export var resize = {
  ios: iosResizeSvg,
  md: mdResizeSvg
};
export var restaurant = {
  ios: iosRestaurantSvg,
  md: mdRestaurantSvg
};
export var returnLeft = {
  ios: iosReturnLeftSvg,
  md: mdReturnLeftSvg
};
export var returnRight = {
  ios: iosReturnRightSvg,
  md: mdReturnRightSvg
};
export var reverseCamera = {
  ios: iosReverseCameraSvg,
  md: mdReverseCameraSvg
};
export var rewind = {
  ios: iosRewindSvg,
  md: mdRewindSvg
};
export var ribbon = {
  ios: iosRibbonSvg,
  md: mdRibbonSvg
};
export var rocket = {
  ios: iosRocketSvg,
  md: mdRocketSvg
};
export var rose = {
  ios: iosRoseSvg,
  md: mdRoseSvg
};
export var sad = {
  ios: iosSadSvg,
  md: mdSadSvg
};
export var save = {
  ios: iosSaveSvg,
  md: mdSaveSvg
};
export var school = {
  ios: iosSchoolSvg,
  md: mdSchoolSvg
};
export var search = {
  ios: iosSearchSvg,
  md: mdSearchSvg
};
export var send = {
  ios: iosSendSvg,
  md: mdSendSvg
};
export var settings = {
  ios: iosSettingsSvg,
  md: mdSettingsSvg
};
export var share = {
  ios: iosShareSvg,
  md: mdShareSvg
};
export var shareAlt = {
  ios: iosShareAltSvg,
  md: mdShareAltSvg
};
export var shirt = {
  ios: iosShirtSvg,
  md: mdShirtSvg
};
export var shuffle = {
  ios: iosShuffleSvg,
  md: mdShuffleSvg
};
export var skipBackward = {
  ios: iosSkipBackwardSvg,
  md: mdSkipBackwardSvg
};
export var skipForward = {
  ios: iosSkipForwardSvg,
  md: mdSkipForwardSvg
};
export var snow = {
  ios: iosSnowSvg,
  md: mdSnowSvg
};
export var speedometer = {
  ios: iosSpeedometerSvg,
  md: mdSpeedometerSvg
};
export var square = {
  ios: iosSquareSvg,
  md: mdSquareSvg
};
export var squareOutline = {
  ios: iosSquareOutlineSvg,
  md: mdSquareOutlineSvg
};
export var star = {
  ios: iosStarSvg,
  md: mdStarSvg
};
export var starHalf = {
  ios: iosStarHalfSvg,
  md: mdStarHalfSvg
};
export var starOutline = {
  ios: iosStarOutlineSvg,
  md: mdStarOutlineSvg
};
export var stats = {
  ios: iosStatsSvg,
  md: mdStatsSvg
};
export var stopwatch = {
  ios: iosStopwatchSvg,
  md: mdStopwatchSvg
};
export var subway = {
  ios: iosSubwaySvg,
  md: mdSubwaySvg
};
export var sunny = {
  ios: iosSunnySvg,
  md: mdSunnySvg
};
export var swap = {
  ios: iosSwapSvg,
  md: mdSwapSvg
};
export var switcher = {
  ios: iosSwitchSvg,
  md: mdSwitchSvg
};
export var sync = {
  ios: iosSyncSvg,
  md: mdSyncSvg
};
export var tabletLandscape = {
  ios: iosTabletLandscapeSvg,
  md: mdTabletLandscapeSvg
};
export var tabletPortrait = {
  ios: iosTabletPortraitSvg,
  md: mdTabletPortraitSvg
};
export var tennisball = {
  ios: iosTennisballSvg,
  md: mdTennisballSvg
};
export var text = {
  ios: iosTextSvg,
  md: mdTextSvg
};
export var thermometer = {
  ios: iosThermometerSvg,
  md: mdThermometerSvg
};
export var thumbsDown = {
  ios: iosThumbsDownSvg,
  md: mdThumbsDownSvg
};
export var thumbsUp = {
  ios: iosThumbsUpSvg,
  md: mdThumbsUpSvg
};
export var thunderstorm = {
  ios: iosThunderstormSvg,
  md: mdThunderstormSvg
};
export var time = {
  ios: iosTimeSvg,
  md: mdTimeSvg
};
export var timer = {
  ios: iosTimerSvg,
  md: mdTimerSvg
};
export var today = {
  ios: iosTodaySvg,
  md: mdTodaySvg
};
export var train = {
  ios: iosTrainSvg,
  md: mdTrainSvg
};
export var transgender = {
  ios: iosTransgenderSvg,
  md: mdTransgenderSvg
};
export var trash = {
  ios: iosTrashSvg,
  md: mdTrashSvg
};
export var trendingDown = {
  ios: iosTrendingDownSvg,
  md: mdTrendingDownSvg
};
export var trendingUp = {
  ios: iosTrendingUpSvg,
  md: mdTrendingUpSvg
};
export var trophy = {
  ios: iosTrophySvg,
  md: mdTrophySvg
};
export var tv = {
  ios: iosTvSvg,
  md: mdTvSvg
};
export var umbrella = {
  ios: iosUmbrellaSvg,
  md: mdUmbrellaSvg
};
export var undo = {
  ios: iosUndoSvg,
  md: mdUndoSvg
};
export var unlock = {
  ios: iosUnlockSvg,
  md: mdUnlockSvg
};
export var videocam = {
  ios: iosVideocamSvg,
  md: mdVideocamSvg
};
export var volumeHigh = {
  ios: iosVolumeHighSvg,
  md: mdVolumeHighSvg
};
export var volumeLow = {
  ios: iosVolumeLowSvg,
  md: mdVolumeLowSvg
};
export var volumeMute = {
  ios: iosVolumeMuteSvg,
  md: mdVolumeMuteSvg
};
export var volumeOff = {
  ios: iosVolumeOffSvg,
  md: mdVolumeOffSvg
};
export var walk = {
  ios: iosWalkSvg,
  md: mdWalkSvg
};
export var wallet = {
  ios: iosWalletSvg,
  md: mdWalletSvg
};
export var warning = {
  ios: iosWarningSvg,
  md: mdWarningSvg
};
export var watch = {
  ios: iosWatchSvg,
  md: mdWatchSvg
};
export var water = {
  ios: iosWaterSvg,
  md: mdWaterSvg
};
export var wifi = {
  ios: iosWifiSvg,
  md: mdWifiSvg
};
export var wine = {
  ios: iosWineSvg,
  md: mdWineSvg
};
export var woman = {
  ios: iosWomanSvg,
  md: mdWomanSvg
};
